
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Countup from 'vux/src/components/countup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'


export default {
components: {
Datetime,
PopupPicker,
Countup,
Popup,Group,PopupHeader,XButton,Radio
},
directives: {
TransferDom
},
data() {
return {
type:1,
showDates:false,
pickerStatus:false,
dateStatus:false,
detailPop:false,
index:0,
startDate:'',
endDate:'',
info:{},
list:[]
}
},
created(){
this.type = this.$route.params.type;
if(this.type == 1){
this.$route.meta.title = '入厂统计';
}else if(this.type == 2){
this.$route.meta.title = '打包统计';
}else if(this.type == 3){
this.$route.meta.title = '出厂统计';
}else{
this.$route.meta.title = '录单统计';
}
document.title = this.$route.meta.title;
this.setDate();
setTimeout(() => {
this.getData();
}, 300);
},
methods: {
setDate() {
this.startDate = this.$func.getCurrentDate();
this.endDate = this.$func.getCurrentDate();
},
showDate(e){
this.index = e;
this.dateStatus = true;
},
previous(){
this.startDate = this.$func.modifyDate(this.startDate,-1);
this.endDate = this.startDate;
this.getData();
},
next(){
this.startDate = this.$func.modifyDate(this.startDate,1);
this.endDate = this.startDate;
this.getData();
},
dateChange(e){
if(this.index > 0){
this.endDate = e;
}else{
this.startDate = e;
}



},
reset(){
this.setDate();
setTimeout(() => {
this.getData();
}, 300);
},
getData() {
if(!this.startDate || !this.endDate){
this.$func.showToast('请选择日期');
return;
}
this.$func.startLoading();
this.$api.contractFactoryData({status:this.type,start:this.startDate,end:this.endDate}).then((res)=>{
if(res){
this.info = res.data;
this.pickerStatus = false;
this.detailPop = false;
this.$func.endLoading();
}
})
},
getDetail() {
if(!this.startDate || !this.endDate){
this.$func.showToast('请选择日期');
return;
}
if(this.detailPop){
this.detailPop = false;
return;
}
this.$func.startLoading();
this.$api.contractFactoryDataDetail({status:this.type,start:this.startDate,end:this.endDate}).then((res)=>{
if(res){
this.list = res.data;
this.detailPop = true;
this.$func.endLoading();
}
})
},

}
}



// WEBPACK FOOTER //
// ./src/pages/inFactoryData.vue